import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/AppBar": AppBar, "@mui/material/Box": Box, "@mui/material/CssBaseline": CssBaseline, "@mui/material/Divider": Divider, "@mui/material/Drawer": Drawer, "@mui/material/IconButton": IconButton, "@mui/icons-material/MoveToInbox": InboxIcon, "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/ListItemText": ListItemText, "@mui/icons-material/Mail": MailIcon, "@mui/icons-material/Menu": MenuIcon, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography } } });
export default ClientProvider;
